import { baseQuery } from '../baseQuery';

type DeleteTechnicianServiceTypePayload = {
  techId: number;
  technicianServiceTypeId: number;
};

export const deleteTechnicianServiceType = async (payload: DeleteTechnicianServiceTypePayload) => {
  const { techId, technicianServiceTypeId } = payload;
  const { data } = await baseQuery(`technicians/${techId}/service-types/${technicianServiceTypeId}`, {
    type: 'DELETE',
  });

  return data;
};
